type IfProps = {
  children?: any
  condition: any
  renderIf: any
  renderElse?: any
}

const If = ({
  children,
  condition,
  renderIf = null,
  renderElse = null,
}: IfProps) => {
  const ifElement = children ? children : renderIf
  const elseElement = renderElse ? renderElse : null
  return condition ? ifElement : elseElement
}

export default If
